import { gsap, Power4 } from "gsap"; 

const header = () => {
    const headerBurger = document.querySelector('.header__burger');

    const headerBurgerHandler = (e) => {
        e.preventDefault();

        if (headerBurger) {
            headerBurger.classList.toggle('header__burger--active');
        }

        $('.header__menu-mobile').slideToggle('visible');
    };

    if (headerBurger) {
        headerBurger.addEventListener('click', headerBurgerHandler);
    }

    if ($(".hero-section-1").length == 0 && $(".hero-section-2").length == 0 && $(".hero-section-3").length == 0 && $(".hero-section-4").length == 0) {
        const elements = {
            logo: ".logo",
            menuItems: ".header__menu ul li",
            desktopBtn: ".header .btn--desktop"
        };

        const loaderTimeline = gsap.timeline({ paused: true, defaults: { ease: Power4.easeInOut } });

        loaderTimeline.to([elements.logo, elements.menuItems, elements.desktopBtn], { duration: 0.5, autoAlpha: 1, stagger: 0.1 }, "-=1.5");

        loaderTimeline.play();
    }
}

export default header;